import { FiShoppingCart, FiCheckCircle, FiCreditCard } from "react-icons/fi";
import OverviewCard from "./OverviewCard";

const STEP_ACCENTS = ["sky", "violet", "amber", "emerald"];

const colorMap = {
    sky: { dot: "bg-sky-500", bar: "from-sky-400 to-sky-600", chip: "bg-sky-50 text-sky-700" },
    violet: { dot: "bg-violet-500", bar: "from-violet-400 to-violet-600", chip: "bg-violet-50 text-violet-700" },
    amber: { dot: "bg-amber-500", bar: "from-amber-400 to-amber-600", chip: "bg-amber-50 text-amber-700" },
    emerald: { dot: "bg-emerald-500", bar: "from-emerald-400 to-emerald-600", chip: "bg-emerald-50 text-emerald-700" },
};

const ConversionFunnel = ({ dashboard }) => {
    const visitors = dashboard.pricing_views || 1;

    const steps = [
        { title: "Pricing Page", value: dashboard.pricing_views, icon: <FiShoppingCart size={14} /> },
        { title: "Plan Selected", value: dashboard.plan_selected, icon: <FiCheckCircle size={14} /> },
        { title: "Checkout", value: dashboard.checkout_started, icon: <FiShoppingCart size={14} /> },
        { title: "Payment Success", value: dashboard.payment_success, icon: <FiCreditCard size={14} /> },
    ];

    return (
        <OverviewCard
            title="Conversion Funnel"
            subtitle="Visitor journey from pricing page to successful payment"
            accent="violet"
        >
            <div className="space-y-4">
                {steps.map((step, index) => {
                    const percentage = ((step.value / visitors) * 100).toFixed(1);
                    const c = colorMap[STEP_ACCENTS[index]];
                    const isLast = index === steps.length - 1;

                    return (
                        <div key={step.title} className="flex gap-3">
                            <div className="flex flex-col items-center">
                                <div className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full ${c.dot} text-white shadow-sm`}>
                                    {step.icon}
                                </div>
                                {!isLast && (
                                    <div className="mt-1 w-px flex-1 bg-slate-200" style={{ minHeight: 18 }} />
                                )}
                            </div>

                            <div className="flex-1 pb-1">
                                <div className="mb-1.5 flex items-center justify-between">
                                    <span className="text-sm font-medium text-slate-700">
                                        {step.title}
                                    </span>

                                    <div className="flex items-baseline gap-1.5">
                                        <span className="text-sm font-semibold tabular-nums text-slate-900">
                                            {step.value}
                                        </span>
                                        <span className={`rounded-full px-1.5 py-0.5 text-[11px] font-medium tabular-nums ${c.chip}`}>
                                            {percentage}%
                                        </span>
                                    </div>
                                </div>

                                <div className="h-2 w-full overflow-hidden rounded-full bg-slate-100">
                                    <div
                                        className={`h-2 rounded-full bg-gradient-to-r ${c.bar} transition-all duration-700`}
                                        style={{ width: `${percentage}%` }}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </OverviewCard>
    );
};

export default ConversionFunnel;